import { faArrowRight as fasArrowRight } from "@awesome.me/kit-3777c2145e/icons/classic/solid";
import { AbstractStep } from "@component/assets/AbstractLeadForm/Steps/AbstractStep";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, FormCheckList, FormDate, FormDecidable } from "bm-ui-kit";
import type { FormApi } from "final-form";
import type { ReactNode } from "react";
import React from "react";
import { Card } from "react-bootstrap";
import { EXTEND_BABY_LOAN_WITH } from "./Step3.data";

export interface Step3Fields {
	birthDate: string;
	inKHR: boolean;
	extendBabyLoanWith: string[];
}

export class Step3 extends AbstractStep<Step3Fields> {
	protected initValues(): Step3Fields {
		return {
			birthDate: undefined,
			inKHR: undefined,
			extendBabyLoanWith: undefined,
		};
	}

	protected renderContent(values: Step3Fields, form: FormApi<Step3Fields>): ReactNode {
		return (
			<>
				<Card.Body>
					<FormDate
						label="A pár hölgy tagja mikor született?"
						name="birthDate"
						autoComplete="bday"
						required
					/>
					<FormDecidable
						label="Szerepel bármelyik fél a KHR (BAR) listán?"
						name="inKHR"
						infoTooltip="Akkor kerülsz a KHR negatív adóslistájára, ha 90 napon keresztül legalább a bruttó minimálbér összegű elmaradásod van."
						required
					/>
					<FormCheckList
						label="Mivel egészítenéd ki a Babaváró hitelt (több is kiválasztható)?"
						name="extendBabyLoanWith"
						options={EXTEND_BABY_LOAN_WITH}
					/>
				</Card.Body>
				<Card.Footer className="text-center">
					<Button
						type="submit"
						icon={<FontAwesomeIcon icon={fasArrowRight} />}
						className={!form.getState().valid ? "disabled" : undefined}
					>
						Tovább
					</Button>
				</Card.Footer>
			</>
		);
	}

	protected getComponentName(): string {
		return "Step3";
	}
}
